import Vue from 'vue'
import Router from 'vue-router'
// eslint-disable-next-line
import {ORIGIN_LINK} from '@spero/spero-utils/src/constants/origin-link'
import queryString from '@spero/spero-utils/src/helpers/queryString'
import session from '@spero/spero-utils/src/helpers/session'
import STORAGE from '@spero/spero-utils/src/constants/STORAGE'

const HelloWorld = () => import('@/pages/hello-world.vue')
const Video = () => import('@/pages/videos/video.vue')
const dataDetail = () => import('@/pages/data-detail/index.vue')
const authorData = () => import('@/pages/author-data/index.vue')
const visionDataDetail = () => import('@/pages/vision/data-detail.vue')
const visionAuthorData = () => import('@/pages/vision/author-data.vue')
const appFM = () => import('@/pages/app-fm/index.vue')
const Download = () => import('@/pages/download')
const GushenPublicity = () => import('@/pages/publicity/gushen.vue')
const FeilongPublicity = () => import('@/pages/publicity/feilong.vue')
const Thematic = () => import('@/pages/thematic/index.vue')
// const authorIndex = () => import('@/pages/author-index')
const authorIndex2 = () => import('@/pages/author-index/index2')
const albumIndex = () => import('@/pages/album-index')
const Topic = () => import('@/pages/topic')
// const LandscapeLive = () => import('@/pages/landscape-live/index.vue')
const PortraitLive = () => import('@/pages/portrait-live/index.vue')
const MainTags = () => import('@/pages/main-tags/index.vue')
const Service = () => import('@/pages/service/index.vue')
const serviceAgreement = () => import('@/pages/protocol/service-agreement.vue')
const rechargeAgreement = () => import('@/pages/protocol/recharge-agreement.vue')
const hotTheme = () => import('@/pages/thematic/hot-theme.vue')
const getCourse = () => import('@/pages/get-course/index.vue')
const gushen = () => import('@/pages/download-follow/gushen')
const feilong = () => import('@/pages/download-follow/feilong')
const guliangquan = () => import('@/pages/coupon/guliangquan')
const feilongquan = () => import('@/pages/coupon/feilongquan')
const Personal = () => import('@/pages/personal')
const ecology = () => import('@/pages/ecology')
const viewsShare = () => import('@/pages/views')
const securitiesTrader = () => import('@/pages/securities-trader')
const securitiesTrader2 = () => import('@/pages/securities-trader/trader2')
const securitiesTrader3 = () => import('@/pages/securities-trader/trader3')

const groupChat = () => import('@/pages/group-chat')

const netPay = () => import('@/pages/net-pay')
const netPayPurchase = () => import('@/pages/net-pay/purchase')
const netPayOrderList = () => import('@/pages/net-pay/order-list')
const netPayOrderDetail = () => import('@/pages/net-pay/order-detail')
const netPayAlbum = () => import('@/pages/net-pay/album')
const netPayBuySucc = () => import('@/pages/net-pay/buy-succ')

const liveLobby = () => import('@/pages/live-lobby')
const report = () => import('@/pages/report')

Vue.use(Router)

const SPERO = 'spero://com.spero.vision'

const numReg = /(\d+)/

const uidReg = /([a-z]+_\d+)/

const tagReg = /([A-z]+\d+)/

const router = new Router({
  routes: [{
    path: '/hello-world',
    name: 'hello-world',
    component: HelloWorld
  },
    {
      path: '/video/:vid',
      name: 'video',
      component: Video,
      meta: {
        title: '视频详情页',
        paramsReg: {
          vid: numReg
        },
        openInstall: {
          spero: `${SPERO}/videoDetail`,
          params: {
            id: ($route) => {
              return $route.params.vid
            }
          }
        }
      }
    },
    {
      path: '/data-detail/:vid',
      name: 'index',
      component: dataDetail,
      meta: {
        paramsReg: {
          vid: numReg
        },
        title: '视频数据详情页'
      }
    },
    {
      path: '/author-data',
      name: 'authorData',
      component: authorData,
      meta: {
        title: '播主数据详情页'
      }
    },
    {
      path: '/vision/data-detail/:vid',
      name: 'visionDataDetail',
      component: visionDataDetail,
      meta: {
        paramsReg: {
          vid: numReg
        },
        title: '视频数据详情页'
      }
    }, {
      path: '/vision/author-data',
      name: 'visionAuthorData',
      component: visionAuthorData,
      meta: {
        title: '播主数据详情页'
      }
    },
    {
      path: '/app-fm',
      name: 'appFM',
      component: appFM,
      meta: {
        title: '财经FM'
      }
    },
    {
      path: '/download',
      name: 'download',
      component: Download,
      meta: {
        title: '股拍下载页'
      }
    },
    {
      path: '/publicity/gushen',
      name: 'publicity-gushen',
      component: GushenPublicity,
      meta: {
        title: '谷神宣传页'
      }
    },
    {
      path: '/publicity/feilong',
      name: 'publicity-feilong',
      component: FeilongPublicity,
      meta: {
        title: '飞龙宣传页'
      }
    },
    {
      path: '/thematic/:id',
      name: 'thematic',
      component: Thematic,
      meta: {
        paramsReg: {
          id: numReg
        },
        title: '股拍',
        openInit: true,
        openInstall: {
          spero: `${SPERO}/theme`,
          params: {
            id: ($route) => {
              return $route.params.id
            },
            type: () => 1,
            title: () => ''
          }
        },
        searchs: {
          entersource: ($route) => {
            return 'h5_2ab01_e004_0-0-0'
          }
        }
      }
    },
    {
      path: '/author/:uid',
      name: 'authorIndex',
      component: authorIndex2,
      meta: {
        paramsReg: {
          uid: uidReg
        },
        title: '股拍',
        openInit: false
      }
    },
    {
      path: '/author2/:uid',
      name: 'authorIndex2',
      component: authorIndex2,
      meta: {
        paramsReg: {
          uid: uidReg
        },
        title: '股拍',
        openInstall: {
          spero: `${SPERO}/authorDetail`,
          params: {
            authorID: ($route) => {
              return $route.params.uid
            }
          }
        }
      }
    },
    {
      path: '/personal/:uid',
      name: 'personalIndex',
      component: Personal,
      meta: {
        paramsReg: {
          uid: uidReg
        },
        title: '股拍'
      }
    },
    {
      path: '/album/:id',
      name: 'albumIndex',
      component: albumIndex,
      meta: {
        paramsReg: {
          id: numReg
        },
        title: '股拍',
        openInit: false
      }
    },
    {
      path: '/topic/:id',
      name: 'topic',
      component: Topic,
      meta: {
        paramsReg: {
          id: numReg
        },
        title: '股拍',
        openInit: true,
        openInstall: {
          spero: `${SPERO}/topicDetail`,
          params: {
            topicId: ($route) => {
              return $route.params.id
            }
          }
        },
        searchs: {
          entersource: ($route) => {
            return `h5_2ab01_e005_0-0-0`
          }
        }
      }
    },
    {
      path: '/landscape-live/:roomId',
      name: 'landscape-live',
      component: PortraitLive,
      meta: {
        title: '股拍'
      }
    },
    {
      path: '/portrait-live/:roomId',
      name: 'portrait-live',
      component: PortraitLive,
      meta: {
        title: ''
      }
    },
    {
      path: '/main-tags/:tagId',
      name: 'main-tags',
      component: MainTags,
      meta: {
        paramsReg: {
          tagId: tagReg
        },
        title: '股拍',
        openInit: true,
        searchs: {
          entersource: ($route) => {
            return `h5_2ab01_e009_0-0-0`
          }
        }
      }
    },
    {
      path: '/service',
      name: 'service',
      component: Service,
      meta: {
        title: '客服'
      }
    },
    {
      path: '/protocol/service-agreement',
      name: 'service-agreement',
      component: serviceAgreement,
      meta: {
        title: '服务协议'
      }
    },
    {
      path: '/protocol/recharge-agreement',
      name: 'recharge-agreement',
      component: rechargeAgreement,
      meta: {
        title: '用户充值协议'
      }
    },
    {
      path: '/hot-theme/:id',
      name: 'hot-theme',
      component: hotTheme,
      meta: {
        paramsReg: {
          id: numReg
        },
        title: '股拍',
        openInit: true,
        openInstall: {
          spero: `${SPERO}/theme`,
          params: {
            id: ($route) => {
              return $route.params.id
            },
            type: () => 4,
            title: () => ''
          }
        },
        searchs: {
          entersource: ($route) => {
            return 'h5_2ab01_e004_0-0-0'
          }
        }
      }
    },
    {
      path: '/get-course',
      name: 'get-course',
      component: getCourse,
      meta: {
        title: '炒股实战课程限时领'
      }
    },
    {
      path: '/download-follow/gushen',
      name: 'gushen',
      component: gushen,
      meta: {
        title: '股拍下载页'
      }
    },
    {
      path: '/download-follow/feilong',
      name: 'feilong',
      component: feilong,
      meta: {
        title: '股拍下载页'
      }
    },
    {
      path: '/coupon/guliangquan',
      name: 'guliangquan',
      component: guliangquan,
      meta: {
        title: '【股拍】 陆家嘴谷神新课首发'
      }
    },
    {
      path: '/coupon/feilongquan',
      name: 'feilongquan',
      component: feilongquan,
      meta: {
        title: '【股拍】 股道飞龙哥新课首发'
      }
    },
    {
      path: '/ecology/:ecologyId',
      name: 'ecolopgy',
      component: ecology,
      meta: {
        paramsReg: {
          ecologyId: numReg
        },
        title: '圈子',
        openInstall: {
          spero: `${SPERO}/circleDetail`,
          params: {
            circleId: ($route) => {
              return $route.params.ecologyId
            }
          }
        }
      }
    },
    {
      path: '/view/share/:viewId',
      name: 'viewShare',
      component: viewsShare,
      meta: {
        paramsReg: {
          viewId: numReg
        },
        title: '观点详情'
      }
    },
    {
      path: '/securities-trader',
      name: 'securitiesTrader',
      component: securitiesTrader,
      meta: {
        title: '开户'
      }
    },
    {
      path: '/securities/trader2',
      name: 'securitiesTrader2',
      component: securitiesTrader2,
      meta: {
        title: '开户'
      }
    },
    {
      path: '/securities/trader3',
      name: 'securitiesTrader3',
      component: securitiesTrader3,
      meta: {
        title: '开户'
      }
    },
    {
      path: '/net-pay/index/:type?',
      name: 'netPayIndex',
      component: netPay,
      meta: {
        title: '精品课程'
      }
    },
    {
      path: '/net-pay/purchase',
      name: 'netPayPurchase',
      component: netPayPurchase,
      meta: {
        title: '我的已购'
      }
    },
    {
      path: '/net-pay/order-list',
      name: 'netPayOrderList',
      component: netPayOrderList,
      meta: {
        title: '我的订单'
      }
    },
    {
      path: '/net-pay/order-detail/:id',
      name: 'netPayOrderDetail',
      component: netPayOrderDetail,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/net-pay/album/:albumId/:videoId?',
      name: 'netPayAlbum',
      component: netPayAlbum,
      props: true,
      meta: {
        paramsReg: {
          albumId: numReg,
          videoId: numReg
        },
        title: '',
        openInit: true
      }
    },
    {
      path: '/net-pay/buy-succ/:id',
      name: 'netPayBuySucc',
      component: netPayBuySucc,
      props: true,
      meta: {
        title: '购买成功'
      }
    },
    {
      path: '/group-chat/:id',
      name: 'groupChat',
      component: groupChat,
      props: true,
      meta: {
        paramsReg: {
          id: numReg
        },
        title: '群聊'
        // openInit: true
        // openInstall: {
        //   spero: `${SPERO}/groupChat`,
        //   params: {
        //     groupId: ($route) => {
        //       return $route.params.id
        //     }
        //   }
        // },
        // searchs: {
        //   entersource: ($route) => {
        //     return 'h5_2ab16_e015_0-0-0'
        //   }
        // }
      }
    },
    {
      path: '/relation-gp',
      name: 'relationGp',
      component: () => import('@/pages/relation-gp'),
      meta: {
        title: '关联股拍'
      }
    },
    {
      path: '/static/recommend',
      name: 'staticRecommend',
      component: () => import('@/pages/static/recommend'),
      meta: {
        title: '推荐有奖，万元现金等你拿！'
      }
    },
    {
      path: '/live-lobby',
      name: 'liveLobby',
      component: liveLobby,
      meta: {
        title: '直播大厅',
        openInit: true,
        openInstall: {
          spero: `${SPERO}/liveHall`,
          params: {
            type: () => 'recommend'
          }
        },
        searchs: {
          entersource: ($route) => {
            return 'h5_1ag01_d002_0-0-0'
          }
        }
      }
    },
    {
      path: '/report/:id',
      name: 'report',
      component: report,
      meta: {
        title: '研报'
      }
    },
    /**
     * 谷粒充值相关
     */
    {
      path: '/login/:loginType?/:bindPhone?',
      name: 'login',
      component: () => import('@/pages/recharge-entry/login.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: () => import('@/pages/recharge-entry/recharge.vue'),
      meta: {
        title: '充值'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const tag = Math.round(new Date().getTime() / 60 / 1000) + ''
  const {origin, pathname, search, hash} = location
  if (['portrait-live', 'landscape-live'].includes(to.name)) {
    location.replace(`${ORIGIN_LINK.h5hd[process.env.ENV]}live/${search}#/${to.params.roomId}`)
    return
  }
  const q = queryString.query(search)

  if (!q.t || q.token) {
    if (!q.t) {
      q.t = tag
    }
    if (q.token) {
      session.set(STORAGE.LOGIN_TOKEN, q.token)
      delete q.token
    }
    return location.replace(`${origin}${pathname}${queryString.objToStr(q)}${hash}`)
  }

  document.title = to.meta.title || '股拍'
  const fullPath = to.fullPath
  Object.assign(to.query, {
    applink: 'spero://'
  })
  if (!to.name && fullPath.match('/publicity/feilong')) {
    return next('/publicity/feilong')
  } else if (!to.name && fullPath.match('/publicity/gushen')) {
    return next('/publicity/gushen')
  }
  for (let k in to.params) {
    let reg = to.meta.paramsReg && to.meta.paramsReg[k]
    if (reg) {
      to.params[k] = reg.exec(to.params[k]) && RegExp.$1
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js